// mediation-quiz-questions.ts

export interface QuizQuestion {
  key: string;
  qKey: string;
  optKeys: { label: string; value: string }[];
}

export const MEDIATION_QUIZ_QUESTIONS: QuizQuestion[] = [
  {
    key: 'dc-member',
    qKey: 'MEDIATION.Q1',
    optKeys: [
      { label: 'MEDIATION.Yes', value: 'Yes' },
      { label: 'MEDIATION.No', value: 'No' },
      { label: 'MEDIATION.DontKnow', value: 'DontKnow' }
    ]
  },
  {
    key: 'prior-action',
    qKey: 'MEDIATION.Q2',
    optKeys: [
      { label: 'MEDIATION.Q2_OPT1', value: 'Court action' },
      { label: 'MEDIATION.Q2_OPT2', value: 'Arbitration' },
      { label: 'MEDIATION.Q2_OPT3', value: 'Other relevant authority' },
      { label: 'MEDIATION.Q2_OPT4', value: 'None of the above' }
    ]
  },
  {
    key: 'non-commercial',
    qKey: 'MEDIATION.Q3',
    optKeys: [
      { label: 'MEDIATION.Yes', value: 'Yes' },
      { label: 'MEDIATION.No', value: 'No' }
    ]
  }
];
